import FaultAnalytics from './container'

export default FaultAnalytics
